import globalMethods from "@/globalMethods";
import {URLS} from "@/constants";
import i18n from "@/i18n";


function createCSVFile(params) {
    const {fileName, blob} = params;
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = fileName;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    window.URL.revokeObjectURL(url);
}


export default {
    namespaced: true,
    state: {},
    mutations: {},
    actions: {
        async downloadCSVTransactions({rootState}, params) {
            const {personalData, company, cashRegister} = rootState;
            const {cashRegisterId, dateFrom, dateTo, os} = params;
            const url = `${URLS.MODEL.CSV.TRANSACTION_CSV_URL}?date-from=${dateFrom}&date-to=${dateTo}&os=${os}&shop-id=${cashRegisterId}`;
            const options = {
                method: "PUT",
                headers: {
                    "Content-Type": "application/json",
                    "X-CSRFToken": globalMethods.getCookie("csrftoken"),
                    role: personalData.role,
                    companyId: company.companyData?.token,
                    timezone: cashRegister.cashRegisterData?.timezone,
                },
                credentials: 'include',
            };
            const successfulHandler = (blob) => {
                const cashRegisterName = cashRegister.cashRegisters.find(cashRegister => cashRegister.id === cashRegisterId).name;
                const fileName = `${i18n.global.t("Sales in {cashRegister} from {dateFrom} to {dateTo}", {cashRegister: cashRegisterName, dateFrom: dateFrom, dateTo: dateTo})}.csv`;
                createCSVFile({fileName: fileName, blob: blob});
                return {successfully: true};
            };
            return globalMethods.sendRequestToGetBlob({url: url, options: options, successfulHandler: successfulHandler});
        },
        async downloadCSVGoods({rootState}, os) {
            const {personalData, company, cashRegister} = rootState;
            const url = `${URLS.MODEL.CSV.GOOD_CSV_URL}?os=${os}`;
            const options = {
                method: "PUT",
                headers: {
                    "Content-Type": "application/json",
                    "X-CSRFToken": globalMethods.getCookie("csrftoken"),
                    role: personalData.role,
                    companyId: company.companyData?.token,
                    timezone: cashRegister.cashRegisterData?.timezone,
                },
                credentials: 'include',
            };
            const successfulHandler = (blob) => {
                const fileName = `${i18n.global.t("Catalog item export")}.csv`;
                createCSVFile({fileName: fileName, blob: blob});
                return {successfully: true};
            };
            return globalMethods.sendRequestToGetBlob({url: url, options: options, successfulHandler: successfulHandler});
        },
        async downloadCSVGoodsTemplate({rootState}, os) {
            const {personalData, company, cashRegister} = rootState;
            const url = `${URLS.MODEL.CSV.GOOD_CSV_URL}?os=${os}`;
            const options = {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                    "X-CSRFToken": globalMethods.getCookie("csrftoken"),
                    role: personalData.role,
                    companyId: company.companyData?.token,
                    timezone: cashRegister.cashRegisterData?.timezone,
                },
                credentials: 'include',
            };
            const successfulHandler = (blob) => {
                const fileName = `${i18n.global.t("Catalog item template")}.csv`;
                createCSVFile({fileName: fileName, blob: blob});
                return {successfully: true};
            };
            return globalMethods.sendRequestToGetBlob({url: url, options: options, successfulHandler: successfulHandler});
        },
        async validateCSVGoods({rootState}, file) {
            const {personalData, company, cashRegister} = rootState;
            const url = URLS.MODEL.CSV.GOOD_CSV_URL;

            const formData = new FormData();
            formData.append('csv', file);

            const options = {
                method: "PATCH",
                headers: {
                    "X-CSRFToken": globalMethods.getCookie("csrftoken"),
                    role: personalData.role,
                    companyId: company.companyData?.token,
                    timezone: cashRegister.cashRegisterData?.timezone,
                },
                body: formData,
                credentials: 'include',
            };
            return globalMethods.sendRequestToGetJson({url: url, options: options});
        },
        async uploadCSVGoods({rootState}, params) {
            const {personalData, company, cashRegister} = rootState;
            const url = URLS.MODEL.CSV.GOOD_CSV_URL;

            const {file, shopsData} = params;
            const formData = new FormData();
            formData.append('csv', file);
            formData.append("shops_data", JSON.stringify(shopsData));

            const options = {
                method: "POST",
                headers: {
                    "X-CSRFToken": globalMethods.getCookie("csrftoken"),
                    role: personalData.role,
                    companyId: company.companyData?.token,
                    timezone: cashRegister.cashRegisterData?.timezone,
                },
                body: formData,
                credentials: 'include',
            };
            return globalMethods.sendRequestToGetJson({url: url, options: options});
        },
        async downloadCSVClients({rootState}, os) {
            const {personalData, company, cashRegister} = rootState;
            const url = `${URLS.MODEL.CSV.CLIENT_CSV_URL}?os=${os}`;
            const options = {
                method: "PUT",
                headers: {
                    "Content-Type": "application/json",
                    "X-CSRFToken": globalMethods.getCookie("csrftoken"),
                    role: personalData.role,
                    companyId: company.companyData?.token,
                    timezone: cashRegister.cashRegisterData?.timezone,
                },
                credentials: 'include',
            };
            const successfulHandler = (blob) => {
                const fileName = `${i18n.global.t("Client export")}.csv`;
                createCSVFile({fileName: fileName, blob: blob});
                return {successfully: true};
            };
            return globalMethods.sendRequestToGetBlob({url: url, options: options, successfulHandler: successfulHandler});
        },
        async downloadCSVClientsTemplate({rootState}, os) {
            const {personalData, company, cashRegister} = rootState;
            const url = `${URLS.MODEL.CSV.CLIENT_CSV_URL}?os=${os}`;
            const options = {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                    "X-CSRFToken": globalMethods.getCookie("csrftoken"),
                    role: personalData.role,
                    companyId: company.companyData?.token,
                    timezone: cashRegister.cashRegisterData?.timezone,
                },
                credentials: 'include',
            };
            const successfulHandler = (blob) => {
                const fileName = `${i18n.global.t("Client template")}.csv`;
                createCSVFile({fileName: fileName, blob: blob});
                return {successfully: true};
            };
            return globalMethods.sendRequestToGetBlob({url: url, options: options, successfulHandler: successfulHandler});
        },
        async validateCSVClients({rootState}, file) {
            const {personalData, company, cashRegister} = rootState;
            const url = URLS.MODEL.CSV.CLIENT_CSV_URL;

            const formData = new FormData();
            formData.append('csv', file);

            const options = {
                method: "PATCH",
                headers: {
                    "X-CSRFToken": globalMethods.getCookie("csrftoken"),
                    companyId: company.companyData?.token,
                    timezone: cashRegister.cashRegisterData?.timezone,
                    role: personalData.role,
                },
                body: formData,
                credentials: 'include',
            };
            return globalMethods.sendRequestToGetJson({url: url, options: options});
        },
        async uploadCSVClients({rootState}, file) {
            const {personalData, company, cashRegister} = rootState;
            const url = URLS.MODEL.CSV.CLIENT_CSV_URL;

            const formData = new FormData();
            formData.append('csv', file);

            const options = {
                method: "POST",
                headers: {
                    "X-CSRFToken": globalMethods.getCookie("csrftoken"),
                    role: personalData.role,
                    companyId: company.companyData?.token,
                    timezone: cashRegister.cashRegisterData?.timezone,
                },
                body: formData,
                credentials: 'include',
            };
            return globalMethods.sendRequestToGetJson({url: url, options: options});
        },
    },
};